import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from "react-router-dom";
// import Footer from './Footer';
import Navbar from './Navbar';
import useGet from './../Hooks/useGet';
import API_ENDPOINTS from '../Config/api';

export default function Layout({ navbarItems, onLinkChange = () => { } }) {

    const location = useLocation();
    useEffect(() => {
        onLinkChange(location.pathname)
    }, [location])

    const contentRef = useRef(null);

    useEffect(() => {
        if (contentRef.current) {
            contentRef.current.scrollTop = 0;
        }
    }, [location.pathname]);

    // const { fetchedData: aziendaDettagli  } = useGet(API_ENDPOINTS.aziendaDettagli);
    
    const { fetchedData: userDetail } = useGet(API_ENDPOINTS.userDetail);
    const { fetchedData: brandingLogo } = useGet(API_ENDPOINTS.brandingLogo);

    return (
        <div className="h-screen flex">
            <div className={`flex flex-col flex-1 transition-all duration-300 `}>
                <div className="sticky top-0 z-50 ">
                    <Navbar navbarItems={navbarItems} aziendaDettagli={userDetail} urlLogo={brandingLogo?.logo_url}/>
                </div>
                <div className="overflow-auto bg-[#F3F4F7]" ref={contentRef} style={{ overflowY: 'auto', height: '100%' }}>
                    <div className="max-w-7xl mx-auto">
                        <Outlet />
                    </div >
                    {/* <Footer /> */}
                </div>
            </div>
        </div>
    );
}
